import { render, staticRenderFns } from "./logVoice.vue?vue&type=template&id=f5e30d7c&scoped=true&"
import script from "./logVoice.vue?vue&type=script&lang=js&"
export * from "./logVoice.vue?vue&type=script&lang=js&"
import style0 from "./logVoice.vue?vue&type=style&index=0&id=f5e30d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e30d7c",
  null
  
)

export default component.exports